// src/encounter/lib/vital-glyph.ts
// ONE mapping from the legacy VitalKind vocabulary (catalog / edit dialog) to the strip's
// ObservationGlyph set — so every vitals surface + its dialogs render the SAME icon system
// (Samer wave-2 verdict 2026-07-23: "the icons here in this modal are not the same icons
// that are outside"). Kinds with no ObservationGlyph (extended anthropometrics/screening)
// map to undefined → no icon, exactly like the strip's value-only extended tiles.
import type { VitalKind, ObservationGlyph } from '@scripsteam/scrips-signal-ds';

export const VITAL_KIND_TO_GLYPH: Partial<Record<VitalKind, ObservationGlyph>> = {
  temp: 'vitals', // the thermometer glyph — same as the strip's Temp tile
  pulse: 'heartRate',
  bp: 'bloodPressure',
  resp: 'respRate',
  o2: 'o2sat',
  height: 'height',
  weight: 'weight',
  bmi: 'bmi',
  // PROD-1549 (2026-09-05): the two context-aware kinds now have their genuine Figma glyphs in
  // the DS — the E2 vitals matrix draws an LMP card (Type=Female) and a "Circumference" card
  // (Type=Newborn) whose icon layer is HeadCircumference.
  headCirc: 'headCircumference',
  lmp: 'lmp',
  // The six kinds with no card in any E2 frame draw the DS's PROPOSED glyphs (drawn 2026-09-05 in
  // the proposal Figma file, awaiting design sign-off — `PROPOSED_GLYPHS` in the DS). Every vitals
  // surface now shows an icon for every kind.
  hipCirc: 'hipCircumference',
  waistCirc: 'waistCircumference',
  waistToHipRatio: 'waistToHipRatio',
  bioage: 'bioAge',
  visualAcuity: 'visualAcuity',
  hearingTest: 'hearingTest',
};
